module.exports = {
  MotionScene: {
    PluginName: "Escena de movimiento",
  },
};
